var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutgoing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5082 8.49176C11.2776 8.26517 11.2776 7.89409 11.5082 7.66369L18.0001 1.17176L15.8948 1.17176C15.5705 1.17176 15.3088 0.910083 15.3088 0.585845C15.3088 0.261607 15.5705 -7.22177e-05 15.8948 -7.22177e-05H19.4141C19.7383 -7.22177e-05 20 0.261607 20 0.585845V4.09738C20 4.42162 19.7383 4.6833 19.4141 4.6833C19.0898 4.6833 18.8282 4.42162 18.8282 4.09738V1.99983L12.3362 8.49176C12.1058 8.72231 11.7348 8.72231 11.5082 8.49176V8.49176Z",
    fill: "#00A545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1396 16.6762C18.1864 17.3129 17.9483 17.8988 17.4716 18.3245C16.2569 19.4065 14.6867 20.0002 13.0539 20.0002C11.2726 20.0002 9.60078 19.3088 8.34304 18.0511L1.94876 11.6606C-0.539406 9.17248 -0.660557 5.16093 1.67533 2.53208C2.10104 2.05557 2.68314 1.81723 3.32368 1.86423C3.96041 1.91107 4.50726 2.23134 4.85881 2.76645L6.84696 5.79369C7.32363 6.52029 7.28457 7.46554 6.7455 8.14133C6.28455 8.72328 6.33139 9.55531 6.8549 10.0787L9.92898 13.1489C10.4523 13.6723 11.2883 13.7193 11.8663 13.2583C12.5461 12.7193 13.4874 12.6762 14.2179 13.1567L17.2452 15.145C17.7725 15.4926 18.0928 16.0395 18.1396 16.6762V16.6762Z",
    fill: "#00A545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/outgoing.96a8807b.svg";
export { ForwardRef as ReactComponent };